import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { withStores } from "stores";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { UitkHeading } from "uitk-react-text";
import { DestinationVideoProps } from "./typings";
import { UitkPlaceholderCard } from "uitk-react-cards";
import LazyLoad from "react-lazyload";

const DestinationVideo = withStores("analytics")((props: DestinationVideoProps) => {
  const { flexComponent, analytics, context } = props;
  const { model } = flexComponent;
  const { title, embeddedUrl: videoUrl } = model;
  const { formatText } = useLocalization();

  if (!videoUrl) {
    return null;
  }

  // This is covered in e2e test
  /* istanbul ignore next */
  React.useEffect(() => {
    const trackVideoClick = () => {
      const { activeElement } = document;
      if (activeElement?.id === "destination-video-iframe") {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: "destination-video",
          action: Action.CLICK,
          rfrr: "video.play"
        };

        sendDelayedTrackEvent(flexTrackingInfo, analytics);
      }
    };

    window.addEventListener("blur", trackVideoClick);

    return () => {
      window.removeEventListener("blur", trackVideoClick);
    };
  }, []);

  return (
    <div className="DestinationVideo uitk-cell all-cell-1-1" id={flexComponent.id}>
      {Boolean(title) && (
        <div className="all-b-margin-four">
          <UitkHeading level={2} size={600}>
            {title}
          </UitkHeading>
        </div>
      )}
      <LazyLoad placeholder={<UitkPlaceholderCard data-testid="destination-video-test-iframe" />}>
        <div className="video-container" data-testid="destination-video-test-iframe">
          <iframe
            id="destination-video-iframe"
            title={formatText("destinationVideo.video.forDestination", context.searchContext.location.defaultName)}
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          />
        </div>
      </LazyLoad>
    </div>
  );
});

export default DestinationVideo;
